import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.tsx";
import { CardReviewApp, RoleReviewApp } from "./card-review.tsx";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root mount point");

const path = window.location.pathname;
createRoot(root).render(
  <StrictMode>
    {path === "/card-review" ? <CardReviewApp /> : path === "/role-review" ? <RoleReviewApp /> : <App />}
  </StrictMode>,
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error: unknown) => {
      console.error("Service worker registration failed", error);
    });
  });
}
